<template>
<!-- 所有设备数量归类组件 -->
  <div>
    <div class="rightcon">
      <div class="Echarts-Title">
             <p class="Echarts-Title-Text">{{$t('lang.dashboard.summary')}}</p>
            </div>
      <v-chart :options="option" :autoresize="true" ref="chart"/>
    </div>
  </div>
</template>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/radar'
import 'echarts/lib/component/polar'
export default {
  props: {
    list: {
      type: Array
    }
  },
  data() {
    return {
      option:{
      tooltip: {
        position: [20, 20]
      },
      legend: {
          top: 20,
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
              color: '#fff',
              fontSize:'100%'
          }
      },
      radar: {
          radius: '60%',
          splitNumber: 8,
          axisLine: {
              lineStyle: {
                  color: '#fff',
                  opacity: .2
              }
          },
          splitLine: {
              lineStyle: {
                  color: '#fff',
                  opacity: .2
              }
          },
          splitArea: {
              areaStyle: {
                  color: '#0074c7',
                  opacity: 1,
                  shadowBlur: 15,
                  shadowColor: 'rgba(0,0,0,.5)',
                  shadowOffsetX: 0,
                  shadowOffsetY: 10,
              }
          },
          indicator: [{
              name: this.$t('lang.dashboard.chieffinancialofficer'),
              min: 0,
          }, {
              name: this.$t('lang.dashboard.Router'),
              min: 0,
          }, {
              name: this.$t('lang.dashboard.PrintStream'),
              min: 0,
          }, {
              name: this.$t('lang.dashboard.Serial'),
              min: 0,
          },
          {
              name: this.$t('lang.dashboard.Other'),
              min: 0,
          }]
      },
      series: [{
          name: `${this.$t('lang.dashboard.summary')}`,
          type: 'radar',
          symbolSize: 0,
          areaStyle: {
              normal: {
                  shadowBlur: 13,
                  shadowColor: 'rgba(0,0,0,.2)',
                  shadowOffsetX: 0,
                  shadowOffsetY: 10,
                  opacity: 1
              }
          },
          data: [{
              value: [],
              // name: '设备数量汇总',
          }]
      }],
      color: ['#ef4b4c'],
      backgroundColor: {
          type: 'radial',
          x: 0.4,
          y: 0.4,
          r: 0.35,
          colorStops: [{
              offset: 0,
              color: '#0074c7' // 0% 处的颜色
          }, {
              offset: .4,
              color: '#0074c7' // 100% 处的颜色
          }, {
              offset: 1,
              color: '#0074c7' // 100% 处的颜色
          }],
          globalCoord: false // 缺省为 false
      }
  }
    }
  },

  components: {
    'v-chart': ECharts
  },
  mounted(){
    this.list.map((val,index)=>{
      this.option.series[0].data[0].value.push(val.value)
    })
  },
  watch:{
    list: {
      handler(newValue, oldValue) {
        let data=[];
        // 找出newValue中item.value的最大值然后判断，如果小于100则将最大值设置为100，大于100就取相邻的最大整百数
        let max = Math.max.apply(Math, newValue.map(function (item) {
          return item.value;
        }));
        if(max<100){
          max=100
        }else{
          max = Math.ceil(max/100)*100
        }
        // 改变this.radar.indicator中每一项的max值
        this.option.radar.indicator.map((val,index)=>{
          val.max=max
        })
        newValue.map((val,index)=>{
        data.push(val.value)
        })
        this.option.series[0].data[0].value=data
      },
      deep: true //深度监听
    }
  }
};
</script>
<style scoped>
.echarts {
  width: 100%;
  height: 90%;
  margin: 0 auto 0 auto;
}
.Echarts-Title{
  width: 100%;
  background-color: rgb(0, 116, 199);
}
.Echarts-Title-Text{
  color: #ffffff;
  font-size: 16px;
  margin-left: 10px;
  padding-top:5px;
  padding-bottom: 5px;
  font-weight: bold;
}
.rightcon {
  background-color: rgb(0, 116, 199);
  height: 25vh;
  width: 100%;
  margin-bottom: 0.2rem;
  border-radius: 2%;
  overflow: hidden;
}
/* .rightcon p {
  color: #ffffff;
  font-size: 0.35rem;
  padding-top: 0.1rem;
  text-align: center;
  margin-bottom: 0.1rem;
} */
.alerecon {
  font-size: 0.3rem;
  border-top: 1px solid #60b0de;
  padding: 0.15rem 0rem;
  border-width: 90%;
  border-top-style: dotted;
}
.alere {
  color: #60b0de;
  font-size: 0.3rem;
  text-indent: 0.2rem;
  margin-right: 0.5rem;
}
.el-tabs__item.is-active {
  color: #60b0de;
  font-size: 0.3rem;
}
.el-tabs__item {
  color: #ffffff;
  font-size: 0.3rem;
}
.el-tabs__item:hover {
  color: #ffffff;
  font-size: 0.3rem;
}
.el-tabs__nav-scroll {
  width: 100%;
}
.listtext {
  font-size: 0.3rem;
  border-top: 1px solid #60b0de;
  padding: 0.15rem 0rem;
  border-width: 90%;
  border-top-style: dotted;
}
</style>
